export default "__VITE_ASSET__DrzYaGe___"